import { STUDIO } from "../data/studio";

export const WhatsAppIcon = ({ size = 24, className = "" }) => (
    <svg width={size} height={size} className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M20.5 11.7a8.5 8.5 0 0 1-12.7 7.4L3 20.5l1.4-4.7a8.5 8.5 0 1 1 16.1-4.1Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="m8 7.2 1.1-.2 1.3 2.6-.9 1c.7 1.4 1.6 2.3 3.1 3l1-.9 2.6 1.3-.2 1.1c-.2 1.1-1.5 1.5-2.6 1.2-3.5-1-5.8-3.3-6.8-6.8-.3-1.1.2-2.1 1.4-2.3Z" fill="currentColor" />
    </svg>
);

export const WhatsApp = () => (
    <a className="whatsapp-float" href={STUDIO.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Chat with Decorcrafts on WhatsApp" title="Chat on WhatsApp" data-testid="floating-whatsapp-button"><WhatsAppIcon size={36} /><span className="whatsapp-tooltip">Let’s talk</span></a>
);